// src/firebase.js (reverted for cloud Firestore)
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore'; // Removed connectFirestoreEmulator import
import { getStorage } from 'firebase/storage'; // Removed connectStorageEmulator import

const isNode = typeof window === 'undefined';

const firebaseConfig = {
  apiKey: "AIzaSyCmjgNdLDj8Jlx1TgltYQBFQKBYwnFTeeg",
  authDomain: "trove-916c9.firebaseapp.com",
  projectId: "trove-916c9",
  storageBucket: "trove-916c9.firebasestorage.app",
  messagingSenderId: "213611646858",
  appId: "1:213611646858:web:a1d018c83bbfdef8050273",
  measurementId: "G-LNPEHYZ76Y"
};
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);